import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";

class UserPasswordContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        requestUserData: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            editMode: false,
            securityLevel: null,
            inputError: [],
            inputParams: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
        };

        this.translate = this.props.baseData.translate;

        this.passwordMinLength = 12;
        this.securityColors = ['#f9f9f9', '#ff352c', '#ff9410', '#fff635', '#6ca413'];

        this.resetInput = this.resetInput.bind(this);
        this.setInputError = this.setInputError.bind(this);
        this.resetInputError = this.resetInputError.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
        this.toggleMode = this.toggleMode.bind(this);

    }

    moveCursorToEnd(field) {

        let temp_value = field.target.value;

        field.target.value = '';
        field.target.value = temp_value;

    }

    editInput(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.target.value;

        if (key === 'newPassword') this.checkPasswordSecurity(event.target.value);

        this.setState({
            inputParams: newInput
        });

    }

    resetInput() {

        this.props.requestUserData();

    }

    enterSaveSettings(event) {

        if (event.keyCode === 13) {
            this.saveSettings();
        } else if (event.keyCode === 27) {
            this.toggleMode();
        }

    }

    saveSettings() {

        const userId = this.props.baseData.userData.id;
        const userEmail = this.props.baseData.userData.email;
        const inputFields = this.state.inputParams;
        const inputChecked = this.checkInput();

        if (userId && userEmail && inputChecked && this.state.securityLevel >= 3) {
            const params = {
                action: 'changePassword',
                id: userId,
                email: userEmail,
                oldPassword: inputFields.oldPassword,
                newPassword: inputFields.newPassword,
            };

            const callback = function (res) {
                if (res.success) {
                    this.resetInput();
                    this.resetInputError();
                    this.toggleMode();
                } else {
                    this.setInputError(res.errors);
                }

                alert(this.translate(res.msgKey));
            }.bind(this);

            this.api.request('SaveUserSettings', params, callback, null);
        }

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    checkPasswordSecurity(password) {

        let securityLevel = 0;

        //  Passwort ist zu kurz, securityLevel = 0.
        if (password.length > 0 && password.length >= this.passwordMinLength) {
            if (password.match(/[A-ZÄÖÜ]{1,}/)) securityLevel++;                                    //  If password contains capital letters, securityLevel + 1.
            if (password.match(/[a-zäöü]{1,}/)) securityLevel++;                                    //  If password contains lowercase letters, securityLevel + 1.
            if (password.match(/\d{1,}/)) securityLevel++;                                          //  If password contains numbers, securityLevel + 1.
            if (password.match(/\W/) || password.match(/[$-/:-?{-~!"^_`\[\]]/)) securityLevel++;    //  If password contains symbols, securityLevel + 1.
        }

        this.setState({securityLevel});

    }

    checkInput() {

        let errors = [];
        let oldPassword = this.state.inputParams.oldPassword;
        let newPassword = this.state.inputParams.newPassword;
        let confirmPassword = this.state.inputParams.confirmPassword;

        this.resetInputError();

        if (newPassword === '') {
            errors.push('errorNewPasswordUnset');
        } else if (newPassword.length < this.passwordMinLength) {
            errors.push('errorNewPasswordToShort');
        } else if (newPassword === oldPassword) {
            errors.push('errorOldPasswordEqualsNew');
        } else if (this.state.securityLevel < 3) {
            errors.push('errorNewPasswordUnsure');
        } else {
            if (confirmPassword === '') {
                errors.push('errorConfirmPasswordUnset');
            } else if (confirmPassword !== newPassword) {
                errors.push('passwordsDontMatch');
            }
        }

        if (oldPassword === '') {
            errors.push('errorOldPasswordUnset');
        }

        if (errors.length > 0) {
            let errorMsg = '';

            errors.forEach(
                (errorKey, index) => {
                    errorMsg += this.translate(errorKey) + '\r\n';
                }
            );

            alert(errorMsg);
        }

        return (errors.length === 0);

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    enterToggleMode(event) {

        if (event.keyCode === 13) {
            this.toggleMode();
        }

    }

    toggleMode() {

        this.setState({
            editMode: !this.state.editMode,
            securityLevel: null,
            inputError: [],
            inputParams: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
        });

    }

    getButtons() {

        if (this.state.editMode) {
            return (
                <span>
                    <a className="formButton" tabIndex="4" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('cancel')}
                    </a>

                    <a className="formButton" tabIndex="5" onClick={() => this.saveSettings()} onKeyDown={(event) => this.enterSaveSettings(event)}>
                        {this.translate('save')}
                    </a>
                </span>
            );
        } else {
            return (
                <span>
                    <a className="formButton" tabIndex="4" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('edit')}
                    </a>
                </span>
            );
        }

    }

    render() {

        const disabled = !this.state.editMode;
        const buttons = this.getButtons();
        const securityColor = (this.state.securityLevel !== null) ? {backgroundColor: this.securityColors[this.state.securityLevel]} : null;

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('changePassword')}</h1>
                </nav>

                <div className="clearfix">
                    <div className="col-xs-12 col-lg-4">
                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('oldPassword')}</td>

                                        <td className="text-left">
                                            <input name="oldPassword"
                                                   className={this.checkInputError('oldPassword')}
                                                   type="password"
                                                   tabIndex="1"
                                                   value={this.state.inputParams.oldPassword}
                                                   autoFocus={true}
                                                   onFocus={(event) => this.moveCursorToEnd(event)}
                                                   disabled={disabled}
                                                   onChange={(event) => this.editInput(event, 'oldPassword')}
                                                   onKeyDown={(event) => this.enterSaveSettings(event)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('newPassword')}</td>

                                        <td className="text-left">
                                            <input name="newPassword"
                                                   className={this.checkInputError('newPassword')}
                                                   type="password"
                                                   tabIndex="2"
                                                   value={this.state.inputParams.newPassword}
                                                   disabled={disabled}
                                                   onChange={(event) => this.editInput(event, 'newPassword')}
                                                   onKeyDown={(event) => this.enterSaveSettings(event)}
                                            />

                                            <span className="formPwSecIcon" style={securityColor}>&nbsp;</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('confirmPassword')}</td>

                                        <td className="text-left">
                                            <input name="confirmPassword"
                                                   className={this.checkInputError('confirmPassword')}
                                                   type="password"
                                                   tabIndex="3"
                                                   value={this.state.inputParams.confirmPassword}
                                                   disabled={disabled}
                                                   onChange={(event) => this.editInput(event, 'confirmPassword')}
                                                   onKeyDown={(event) => this.enterSaveSettings(event)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan webElement">&nbsp;</td>

                                        <td className="text-left">{buttons}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-xs-12 col-lg-4">
                        <div>
                            <p>{this.translate('changePasswordNoteText')}</p>
                        </div>

                        <div>
                            <ul>
                                <li>{this.translate('changePasswordNote1')}</li>
                                <li>{this.translate('changePasswordNote2')}</li>
                                <li>{this.translate('changePasswordNote3')}</li>
                                <li>{this.translate('changePasswordNote4')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default UserPasswordContainer;